<template>
  <a-drawer width="35%" placement="right" :closable="false" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('buyVideo.purchaseDetail') }}</b>
    </a-divider>
    <a-descriptions :title="$t('buyVideo.purchaseInfo')" layout="vertical" bordered>
      <a-descriptions-item :label="$t('buyVideo.userNickname')">
        {{ form.nickname || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.videoName')">
        {{ form.videoName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.orderNo')">
        {{ form.orderNo || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.serialNumber')">
        {{ form.serialNumber || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.type')">
        <span v-if="form.type === 0">{{ $t('buyVideo.free') }}</span>
        <span v-else-if="form.type === 1">{{ $t('buyVideo.coin') }}</span>
        <span v-else-if="form.type === 2">{{ $t('buyVideo.coin') }}</span>
        <span v-else-if="form.type === 3">{{ $t('buyVideo.watchAd') }}</span>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.price')">
        {{ form.price || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.createTime')">
        {{ parseTime(form.createTime) || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('buyVideo.remark')" span="2" v-if="form.remark">
        {{ form.remark }}
      </a-descriptions-item>
    </a-descriptions>
    <div class="bottom-control" style="margin-top: 20px; text-align: right;">
      <a-button type="primary" @click="onClose">{{ $t('buyVideo.close') }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
export default {
  name: 'DetailForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      open: false,
      form: {}
    }
  },
  methods: {
    onClose () {
      this.open = false
      this.form = {}
    },
    /** 显示详情 */
    handleDetail (row) {
      if (!row) {
        this.$message.warning(this.$t('buyVideo.dataNotExist'))
        return
      }
      // 直接使用传入的数据，不调用接口
      this.form = { ...row }
      this.open = true
    }
  }
}
</script>

<style scoped lang="less">
.bottom-control {
  margin-top: 20px;
  text-align: right;
}
</style>

